var _path, _mask, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAu = function SvgAu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E4E9D",
    d: "M0 0h16v12H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "au_svg__a",
    width: 10,
    height: 7,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h10v7H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#au_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "M11-1.167-1 8.167"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DC251C",
    strokeWidth: 0.75,
    d: "M11-1.167-1 8.167"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2.5,
    d: "m-1-1.167 12 9.334"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DC251C",
    strokeWidth: 0.75,
    d: "m-1-1.167 12 9.334"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3,
    d: "M5 0v7M0 3.5h10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DC251C",
    strokeWidth: 2,
    d: "M5 0v7M0 3.5h10"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 2.5,
    r: 0.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 5.5,
    r: 0.5,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 4.5,
    r: 0.5,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 6.5,
    r: 0.5,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 9.5,
    r: 0.5,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 10,
    r: 1,
    fill: "#fff"
  })));
};
export default SvgAu;